import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'

import {
  Grid, Button, CardContent,
  TextField, Typography, MenuItem
} from '@material-ui/core'

import States from '../states.json'

import { createNewUnit } from '../../../../redux/actions'

import { NotificationToast } from '../../tools/Toast'
import { handleTextPrepper } from '../../../../utils'

/**
 * Returns org unit mgmt create form
 */
const OrgUnitMgmtCreateUnit = ({
  onBackTrack, onSaveBackTrack, unitName, selectedKey, classes, textClasses
}) => {
  const [form, setForm] = useState({
    unitName: '',
    unitDesc: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    postalCode: ''
  })

  const dispatch = useDispatch()

  const onChange = (prop) => e => {
    e.preventDefault()
    setForm({ ...form, [prop]: e.target.value })
  }

  const submitForm = async () => {
    const ancestorID = selectedKey

    // Default the monitoring times to a 24 hour period
    const startTime = moment().startOf('day').unix()
    const endTime = moment().endOf('day').unix()

    const info = {
      unitName: handleTextPrepper(form.unitName),
      unitDesc: handleTextPrepper(form.unitDesc),
      address: handleTextPrepper(form.address),
      address2: handleTextPrepper(form.address2),
      city: handleTextPrepper(form.city),
      state: handleTextPrepper(form.state),
      postalCode: handleTextPrepper(form.postalCode),
      monitorStartTime: startTime,
      monitorEndTime: endTime
    }
    dispatch(createNewUnit(info, ancestorID, fireSuccess, fireFailure))
    onSaveBackTrack()
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Unit created successfully!')
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to create unit.')
  }

  const getStateOptions = () => {
    const items = []
    for (const [key, value] of Object.entries(States)) {
      items.push(<MenuItem id={key} key={key} value={key}>{value}</MenuItem>)
    }
    return items
  }

  const isEnabled = form.unitName.length > 0 && form.unitDesc.length > 0
  // form.city.length > 0 && form.state.length > 0 && form.postalCode.length > 0

  const changesMade = form.unitName !== '' || form.unitDesc !== '' || form.address !== '' || form.address2 !== '' ||
    form.city !== '' || form.state !== '' || form.postalCode !== ''

  return (
    <CardContent className='mt-2 ml-1'>
      <Grid item container direction='row' className='ml-1 mt-2'>
        <Button className={classes.greenBtn} variant='contained' onClick={(e) => { e.preventDefault(); onBackTrack(changesMade) }}>Back</Button>
      </Grid>
      <Grid item container direction='row' className='my-3 ml-1'>
        <Grid item container direction='column' sm={7}>
          {/* <h4 className='unselectable'>Create New Unit</h4> */}
          <Typography variant='h4' color='primary' className='font-weight-bold' classes={{ colorPrimary: classes.greyColor }}>Create New Unit</Typography>
        </Grid>
        <Grid item container direction='column' sm={4} justify='flex-end'>
          <Grid item container direction='row' justify='flex-end'>
            <h5 className='mx-auto unselectable'>Parent Unit</h5>
            <span className='badge badge-primary mx-auto unselectable text-truncate' style={{ width: 'fit-content', maxWidth: '100%', fontSize: '1.5rem' }}>{unitName}</span>
            {/* <TextField value={unitName} className='p-2' disabled /> */}
          </Grid>
        </Grid>
      </Grid>
      <Grid item container direction='row' className='ml-1'>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={5} className='mr-2'>
              <h5>Unit Name</h5>
              <TextField
                value={form.unitName}
                onChange={onChange('unitName')}
                placeholder='Unit Name'
                name='unitName'
                id='unitName'
                error={form.unitName.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={6}>
              <h5>Unit Description</h5>
              <TextField
                value={form.unitDesc}
                onChange={onChange('unitDesc')}
                placeholder='Unit Description'
                name='unitDesc'
                id='unitDesc'
                error={form.unitDesc.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              // multiline
              // rows='2'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={5} className='mr-2'>
              <h5>Address</h5>
              <TextField
                value={form.address}
                onChange={onChange('address')}
                placeholder='Address'
                name='address'
                id='address'
                // error={form.address.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={6}>
              <h5>Address 2</h5>
              <TextField
                value={form.address2}
                onChange={onChange('address2')}
                placeholder='Address 2'
                name='address2'
                id='address2'
                // error={form.address2.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={4} className='mr-2'>
              <h5>City</h5>
              <TextField
                value={form.city}
                onChange={onChange('city')}
                placeholder='City'
                name='city'
                id='city'
                // error={form.city.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
            <Grid item container direction='column' sm={4} className='mr-2'>
              <h5>State</h5>
              <TextField
                value={form.state}
                defaultValue='AL'
                onChange={onChange('state')}
                name='state'
                id='state'
                // error={form.state.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
                select
              >
                {getStateOptions()}
              </TextField>
            </Grid>
            <Grid item container direction='column' sm={3}>
              <h5>Zip</h5>
              <TextField
                value={form.postalCode}
                onChange={onChange('postalCode')}
                placeholder='Zip Code'
                name='postalCode'
                id='postalCode'
                // error={form.postalCode.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction='row' className='justify-content-end mt-5 mb-3 mr-1'>
          <Button
            className={classes.saveBtn}
            variant='contained'
            onClick={(e) => { e.preventDefault(); submitForm() }}
            disabled={!isEnabled}
          >
            Create Unit
          </Button>
        </Grid>
      </Grid>
    </CardContent>
  )
}

export default OrgUnitMgmtCreateUnit
